'use strict';

module.exports = function (ngModule) {
    require('./qrcode')(ngModule);
    require('./alert')(ngModule);
    require('./appreplace')(ngModule);
    // require('./chordchart')(ngModule);
    require('./coichart')(ngModule);
    require('./copyright')(ngModule);
    require('./datepicker')(ngModule);
    require('./forcechart')(ngModule);
    require('./geochart')(ngModule); // import dc
    require('./head')(ngModule);
    require('./lateralmap')(ngModule);
    require('./iocdesc')(ngModule);
    require('./iocattribute')(ngModule);
    require('./lanegraph')(ngModule);
    require('./linechart')(ngModule);
    require('./machicon')(ngModule);
    require('./numbersonly')(ngModule);
    require('./piechart')(ngModule);
    require('./rowchart')(ngModule); // import dc
    require('./searchbar')(ngModule);
    require('./services')(ngModule);
    require('./severitylevels')(ngModule);
    require('./sevreplace')(ngModule);
    require('./sidebar')(ngModule);
    require('./sidebaricon')(ngModule);
    require('./table')(ngModule);
    require('./treechart')(ngModule);
    require('./rightclick')(ngModule);
}



/** WEBPACK FOOTER **
 ** ./src/pages/directives/index.js
 **/